import React from 'react';
import { Container } from 'styles';
import { ColumnContent, ColumnContentSmall } from 'styles/ColumnContent';

import * as S from './styles';

const UserTypes = () => (
    <S.UserTypeWrapper>
        <Container>
            <ColumnContent>
                <ColumnContentSmall>
                    <S.UserTypeText>Qual tipo de informação você está buscando?</S.UserTypeText>
                </ColumnContentSmall>

                <S.CustomColumnContentLarge>
                    <S.UserTypeCard to="/categoria?type=participant">
                        <S.UserTypeCardIcon icon={`${process.env.PUBLIC_URL}/images/icons/user.svg`} />
                        <S.UserTypeCardTitle>Informações para</S.UserTypeCardTitle>
                        <S.UserTypeCardTitleHighlight>Participantes</S.UserTypeCardTitleHighlight>

                        <S.UserTypeCardText>Comprei ingresso ou participei de um evento</S.UserTypeCardText>
                    </S.UserTypeCard>

                    <S.UserTypeCard to="/categoria?type=organizer">
                    <S.UserTypeCardIcon icon={`${process.env.PUBLIC_URL}/images/icons/producer.svg`} />
                        <S.UserTypeCardTitle>Informações para</S.UserTypeCardTitle>
                        <S.UserTypeCardTitleHighlight>Organizadores</S.UserTypeCardTitleHighlight>

                        <S.UserTypeCardText>Organizei ou vou organizar um evento</S.UserTypeCardText>
                    </S.UserTypeCard>
                </S.CustomColumnContentLarge>
            </ColumnContent>
        </Container>
    </S.UserTypeWrapper>
);

export default UserTypes;
